import { Stack } from "@mui/material";
import { noop } from "lodash-es";
import { useMemo, useState } from "react";

import VehicleDamageViewModal from "@/common/components/Entity/VehicleDamage/View/VehicleDamageViewModal";
import { Mapper } from "@/common/mapping/mapper";
import { ApiEnumName, enumService } from "@/common/services/enum";
import {
  VehicleActualStateDto,
  VehicleDamageDto,
  VehicleDamageState,
} from "@/core/api/generated/v1";

import {
  GenericDamageViewerMode,
  VisualModelEditorOfGenericDamage,
} from "../GenericDamage/VisualModelEditorOfGenericDamage";

export interface VehicleDamagesVisualModelViewerProps {
  actualState: Nil<VehicleActualStateDto>;
  onDamageDeleted: () => void;
}

export function VisualModelViewerOfVehicleActualState({
  actualState,
  onDamageDeleted,
}: VehicleDamagesVisualModelViewerProps) {
  const [vehicleDamageToView, setVehicleDamageToView] = useState<VehicleDamageDto | null>(null);

  const genericDamages = useMemo(
    () =>
      actualState?.damages?.map((x) => Mapper.visualModel.mapVehicleDamageDtoToGenericDamage(x)) ||
      [],
    [actualState],
  );

  return (
    <Stack spacing={2}>
      {actualState && (
        <VisualModelEditorOfGenericDamage
          mode={GenericDamageViewerMode.View}
          vehicleId={actualState.vehicle?.id}
          visualModelId={undefined}
          visualModel={undefined}
          isAutoPickVisualModel
          damages={genericDamages}
          isDisplayOld
          isDisplayList={false}
          isViewOldEnabled
          isViewEnabled
          oldDamagesDisplay={{
            defaultStates: [],
            isStateTogglesEnabled: true,
            allowedStates: enumService.getEnumValues(ApiEnumName.VehicleDamageState, {
              exceptNone: true,
              except: [VehicleDamageState.Actual],
            }),
          }}
          onView={(damage) => {
            if (damage.data) {
              setVehicleDamageToView(damage.data);
            }
          }}
          onCreated={noop}
          onUpdated={noop}
          onDeleted={noop}
          onManyChanged={noop}
        />
      )}

      {/* Vehicle damage view modal */}
      {vehicleDamageToView && (
        <VehicleDamageViewModal
          open={!!vehicleDamageToView}
          onClose={() => {
            setVehicleDamageToView(null);
          }}
          viewProps={{
            vehicleId: vehicleDamageToView.vehicle?.id,
            vehicleDamageId: vehicleDamageToView.id,
            vehicleDamage: vehicleDamageToView,
            onDelete: () => {
              setVehicleDamageToView(null);
              onDamageDeleted();
            },
          }}
        />
      )}
    </Stack>
  );
}
